import { JSX, PropsWithChildren } from "react";
import clsx from "clsx";
import { motion, AnimatePresence } from "framer-motion";

interface CardWrapperProps extends PropsWithChildren {
  classNames?: {
    wrapper?: string;
    header?: string;
  };
  title?: string;
  subtitle?: string | JSX.Element;
  headerControl?: React.ReactNode;
  assessedFirstName?: string;
  assessedLastName?: string;
  assessedRole?: string;
  stepCurrent?: number;
  stepsTotal?: number;
}

export const CardWrapper = (props: CardWrapperProps): JSX.Element => {
  const {
    children,
    classNames,
    headerControl,
    title,
    subtitle,
    assessedFirstName,
    assessedLastName,
    assessedRole,
    stepCurrent,
    stepsTotal,
  } = props;

  const progressPercentage = stepCurrent && stepsTotal ? (stepCurrent / stepsTotal) * 100 : 0;

  return (
    <AnimatePresence initial={false}>
      <motion.div
        initial={false}
        className={clsx(
          "w-full rounded-4xl bg-white shadow-[0_0_32px_-8px_rgba(165,44,161,0.12)]",
          classNames?.wrapper,
        )}
        layout
        transition={{ duration: 0.2, ease: "linear" }}
      >
        <div className="border-b-2 border-gray-100 px-10 py-6">
          {assessedFirstName && (
            <div className="text-eerie-black flex flex-col text-sm">
              <span className="font-semibold">
                {assessedFirstName} {assessedLastName}
              </span>
              {assessedRole && <span>{assessedRole}</span>}
            </div>
          )}
          <div className="mt-4 flex items-center justify-between">
            {title && (
              <div key="hdr" className={clsx("flex w-full flex-col gap-5", classNames?.header)}>
                <h1 className="font-family-third max-w-10/12 text-[32px] font-semibold">{title}</h1>
                {subtitle && <p className="font-family-third text-[20px]">{subtitle}</p>}
              </div>
            )}
            <div className="flex items-center gap-2.5">
              {stepCurrent && stepsTotal && (
                <div className="flex items-center gap-2.5">
                  <div className="relative h-2 w-44">
                    <div className="absolute h-full w-full rounded-2xl bg-gray-100" />
                    <div
                      className="bg-primary absolute h-full rounded-2xl"
                      style={{ width: `${progressPercentage}%` }}
                    />
                  </div>
                  <span className="whitespace-nowrap">
                    Step {stepCurrent} of {stepsTotal}
                  </span>
                </div>
              )}
            </div>
          </div>
          {headerControl && <div className="mt-4 flex justify-end">{headerControl}</div>}
        </div>
        <motion.div layout="size">{children}</motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
